import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;
const deleteQuery = (id) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.MY_QUERIES.DELETE_QUERY,
    id,
    cancelToken
  );
};

export default deleteQuery;
